import { wrapUrlSafe as wrapUrlSafeMonorepo, getLocale } from '@alltrails/shared/utils/languageSupport';
import LanguageRegionCode from '@alltrails/shared/types/LanguageRegionCode';

function wrapUrlSafe(url: string, languageRegionCode: LanguageRegionCode) {
  // No action if URL is already language-adjusted (wrapUrlSafe is sometimes called twice)
  if (url && languageRegionCode !== LanguageRegionCode.English) {
    const matchRegex = new RegExp(`^\\/${getLocale(languageRegionCode)}\\/(.*)`);
    if (url.match(matchRegex)) {
      return url;
    }
  }
  return wrapUrlSafeMonorepo(url, languageRegionCode);
}

const LanguageSupportUtil = {
  // deprecated
  // Do not use LanguageSupportUtil.wrapUrlSafe. Import wrapUrlSafe from the module exports below.
  wrapUrlSafe,
  findRecordFieldWithLocale(record: any, field: string, locale = 'en-US') {
    let translatedField = `${field}_${locale}`;
    if (translatedField in record) {
      return record[translatedField];
    }

    // TODO TOOLS-802 Fail-back to using the _xx key if the _xx-YY is absent
    // Can be removed once Algolia is fully populated
    // check sees if it exists and if it's falsey
    translatedField = `${field}_${locale.substring(0, 2)}`;
    if (record[translatedField]) {
      return record[translatedField];
    }

    if (record[field]) {
      return record[field];
    }

    return '';
  }
};

export default LanguageSupportUtil;
export { LanguageSupportUtil, wrapUrlSafe };
